export const SET_LIST = 'SET_LIST';
export const SET_PROFILES = 'SET_PROFILES';
export const SET_ENTERPRISES = 'SET_ENTERPRISES';
export const SET_ERRORS = 'SET_ERRORS';
export const SET_AGENT = 'SET_AGENT';
